'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/ui/button';
import { useGetPlanInfo } from '@/hooks/useGetPlanInfo';
import { SignedIn, SignedOut, SignInButton, UserButton, useUser } from '@clerk/clerk-react';
import Link from 'next/link';
import { VODojoLogo } from '@/components/VODojoLogo';
import { useQuery } from 'convex/react';
import { api } from '../../../convex/_generated/api';
import { Toaster } from 'sonner';
import { useIsWindows } from '@/hooks/useIsWindows';
export default function WebLayout(t0) {
  const $ = _c(23);
  const {
    children
  } = t0;
  const {
    user
  } = useUser();
  const {
    isSubscribed
  } = useGetPlanInfo();
  const flags = useQuery(api.flags.getMyFlags);
  const isWindows = useIsWindows();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link href="/web"><Button variant="ghost" size="icon"><VODojoLogo size={32} /></Button></Link>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== flags || $[2] !== isSubscribed) {
    t2 = !isSubscribed && flags?.["show-subscribe-button"] && <Link href="/web/checkout"><Button>Get Cloud Storage</Button></Link>;
    $[1] = flags;
    $[2] = isSubscribed;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <SignedIn>{t2}</SignedIn>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isWindows) {
    t4 = isWindows && <Link href="https://vodojo-releases.s3.us-east-1.amazonaws.com/vodojo/win32/x64/vodojo-latest.exe"><Button>Download the app</Button></Link>;
    $[6] = isWindows;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex-1" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = user?.username;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <UserButton />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6) {
    t8 = <SignedIn>{t6}{t7}</SignedIn>;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SignedOut><SignInButton forceRedirectUrl={typeof window === "undefined" ? "/web" : window.location.href}><Button>Sign In</Button></SignInButton></SignedOut>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t8) {
    t10 = <div className="flex flex-row gap-2 p-2 border-b border-muted-foreground items-center">{t1}{t3}{t4}{t5}{t8}{t9}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t8;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Toaster />;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== children) {
    t12 = <div className="flex-1">{children}{t11}</div>;
    $[18] = children;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t12) {
    t13 = <div className="flex flex-col bg-richblack min-h-screen w-full">{t10}{t12}</div>;
    $[20] = t10;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}